<script setup>

import {onMounted, ref} from "vue";
import {useStore} from "vuex";

import {usePermission} from "../../composables/resources/js/composables/permissions.js";

const {hasRole, hasPermission} = usePermission();

const menu_collapse = ref('dashboard');
onMounted(() => {
  let domain = window.location.protocol + '//' + window.location.host;
  const selector = $('#sidebar a[href="' + domain + window.location.pathname + '"]');
  if (selector) {
    const ul = selector.closest('ul.collapse');
    if (ul) {
      let ele = ul.closest('li.menu').find('.dropdown-toggle');
      if (ele && ele.length > 0) {
        $(ul).addClass('show');
      }
    } else {
      selector.click();
    }
  }
});

const toggleMobileMenu = () => {
  if (window.innerWidth < 991) {
    useStore().commit('toggleSideBar', !useStore().state.is_show_sidebar);
  }
};

</script>

<template>
  <!--  BEGIN SIDEBAR  -->
  <div class="sidebar-wrapper sidebar-theme">
    <nav ref="menu" id="sidebar">
      <div class="shadow-bottom"></div>
      <ul class="list-unstyled menu-categories" id="accordionMenu">
        <li class="menu" :class="{'active': $page.component === 'Dashboard'}">
          <Link :href="route('dashboard.index')" class="dropdown-toggle" aria-expanded="false">
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-home">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
              <span>Pulpit</span>
            </div>
          </Link>
        </li>

        <li v-if="hasPermission('canViewClients')" class="menu" :class="{'active': $page.url.startsWith('/customers')}">
          <Link href="#customers" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed">
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-users">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span>Kontrahenci</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>
          <ul class="submenu list-unstyled collapse" id="customers" data-bs-parent="#accordionMenu" style="">
            <li :class="{'active': $page.url === '/customers'}">
              <Link :href="route('customers.index')"> Lista kontrahentów</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/customers/create')}">
              <Link :href="route('customers.create')"> Utwórz kontrahenta</Link>
            </li>
            <li v-if="hasRole('ADMIN')" :class="{'active': $page.url === '/customers-categories'}">
              <Link :href="route('customers-categories.index')">Kategorie kontrahentów</Link>
            </li>
          </ul>
        </li>

        <li v-if="hasPermission('canViewOffers')" class="menu"
            :class="{'active': $page.url.startsWith('/offers') && !$page.url.startsWith('/offers?glowice=1')}">
          <Link href="#offers" data-bs-toggle="collapse"
                aria-expanded="false"
                class="dropdown-toggle collapsed">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-offer">
                <path d="M4 4h16v16H4z"></path>
                <line x1="8" y1="8" x2="16" y2="8"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
                <line x1="8" y1="16" x2="12" y2="16"></line>
                <polyline points="16 16 18 18 22 14"></polyline>
              </svg>
              <span>Oferty</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="offers" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canEditOffers')"
                :class="{'active': $page.url.startsWith('/offers') && !$page.url.startsWith('/offers?glowice=1')}">
              <Link :href="route('offers.index')"> Lista ofert</Link>
            </li>
            <li v-if="hasPermission('canEditOffers')"
                :class="{'active': ( $page.url.startsWith('/offers/create') || $page.url.startsWith('/offers/create-from-copy' )) && !$page.url.startsWith('/offers/create?glowice=1')}">
              <Link :href="route('offers.create')"> Utwórz Ofertę</Link>
            </li>
            <li v-if="hasPermission('canEditOffersTemplates')"
                :class="{'active': $page.url.startsWith('/offers-templates')}">
              <Link :href="route('offers.templates.show')">Edycja szablonów</Link>
            </li>
          </ul>
        </li>

        <li v-if="hasPermission('canViewOffersGlowice')" class="menu"
            :class="{ 'active': $page.url.startsWith('/offers') && $page.props?.glowice == '1' }">
          <Link href="#offersHeads" data-bs-toggle="collapse"
                :aria-expanded="$page.url.startsWith('/offers') && (!$page.props?.glowice || $page.props.glowice !== '1')"
                class="dropdown-toggle collapsed"
                preverse-state>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-offer-head">
                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                <line x1="8" y1="8" x2="16" y2="8"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
                <line x1="8" y1="16" x2="12" y2="16"></line>
                <circle cx="18" cy="18" r="2"></circle>
                <line x1="18" y1="14" x2="18" y2="16"></line>
                <line x1="18" y1="20" x2="18" y2="22"></line>
                <line x1="14" y1="18" x2="16" y2="18"></line>
                <line x1="20" y1="18" x2="22" y2="18"></line>
              </svg>

              <span>Oferty Głowice</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>
          <ul class="submenu list-unstyled collapse" id="offersHeads" data-bs-parent="#accordionMenu"
              :class="{ show: $page.url.startsWith('/offers') && $page.props?.glowice === '1' }"
          >
            <li v-if="hasPermission('canEditOffersGlowice')"
                :class="{ 'active': $page.url.startsWith('/offers?glowice=1')}">
              <Link :href="route('offers.index', {glowice: true})"> Lista ofert głowic</Link>
            </li>
            <li v-if="hasPermission('canEditOffersGlowice')"
                :class="{ 'active': $page.url.startsWith('/offers/create') && $page.props?.glowice === '1' }">
              <Link :href="route('offers.create', {glowice: true})"> Utwórz Ofertę</Link>
            </li>
            <li v-if="hasPermission('canEditOffersGlowiceTemplates')"
                :class="{'active': $page.url.startsWith('/offers-heads-templates')}">
              <Link :href="route('offers-heads.templates.show')">Edycja szablonów</Link>
            </li>
          </ul>
        </li>

        <li class="menu" v-if="hasPermission('canViewProjects') || hasPermission('canViewProjectsGlowice')"
            :class="{'active': $page.url.startsWith('/projects')}">
          <Link href="#projects" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-box">
                <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                <line x1="12" y1="22.08" x2="12" y2="12"></line>
              </svg>
              <span>Projekty</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>
          <ul class="submenu list-unstyled collapse" id="projects" data-bs-parent="#accordionMenu" style="">
            <li v-if="hasPermission('canViewProjects')"
                :class="{'active': $page.component === 'Projects/Index' || $page.component === 'Projects/Show' || $page.component.startsWith('Projects/project')}">
              <Link :href="route('projects.index')"> Lista projektów</Link>
            </li>
            <li :class="{'active': $page.url === '/projects/create'}" v-if="hasPermission('canEditBasicProject')">
              <Link :href="route('projects.create')"> Utwórz projekt</Link>
            </li>
            <li v-if="hasPermission('canViewProjectsGlowice')"
                :class="{'active': $page.component === 'Glowice/Index' || $page.component === 'Glowice/Show' || $page.component.startsWith('Glowice/project')}">
              <Link :href="route('glowice.index')"> Lista Głowic</Link>
            </li>
            <li :class="{'active': $page.component === 'Projects/Index/ResourceSchedule'}"
                v-if="hasPermission('canViewScheduleProject')">
              <Link :href="route('projects.projects-resourceSchedule')"> Harmonogram zasobów</Link>
            </li>
            <li :class="{'active': $page.component === 'Projects/Index/PaymentsStatus'}"
                v-if="hasPermission('canViewPaymentsProject')">
              <Link :href="route('projects.projects-paymentsStatus')">Status płatności</Link>
            </li>
            <li :class="{'active': $page.component === 'Projects/Index/Warranty'}"
                v-if="hasPermission('canViewWarrantyProject')">
              <Link :href="route('projects.projects-warranty')">Gwarancja</Link>
            </li>
            <li :class="{'active': $page.component === 'Projects/DefaultSuppliers/Index'}"
                v-if="hasRole('ADMIN')">
              <Link :href="route('projects.default-suppliers.index')">Domyślni Dostawcy</Link>
            </li>
          </ul>
        </li>

        <li v-if="hasPermission('canViewProdukcja')" class="menu"
            :class="{'active': ($page.url === '/production_out')}">
          <Link href="#production" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed"
                preverse-state>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-settings">
                <circle cx="12" cy="12" r="3"></circle>
                <path
                    d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.09a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
              </svg>
              <span>Produkcja</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="production" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canViewProdukcjaZewn') && ($page.url === '/production_out' || ($page.url !== '/producents_out' && $page.url !== '/productionout_statusy'))"
                 :class="{'active': $page.url === '/production_out'}">
              <Link :href="route('production.out.index')">Zamówienia zewnętrzne</Link>
            </li>
            <li v-if="hasPermission('canViewProdukcjaZewn') && $page.url === '/producents_out'"
                :class="{ active: $page.url === '/producents_out'}">
              <Link :href="route('producents.out.index')">Zamówienia zewnętrzne</Link>
            </li>
            <li v-if="hasPermission('canViewProdukcjaZewn') && $page.url === '/productionout_statusy'"
                :class="{ active: $page.url === '/productionout_statusy'}">
              <Link :href="route('production.out.statusy')">Zamówienia zewnętrzne</Link>
            </li>			
            <li v-if="hasPermission('canViewMaszyny')" :class="{ active: $page.url === '/production_machine'}">
              <Link :href="route('production.machine')">Produkcja - Maszyny</Link>
            </li>	
			<li v-if="hasPermission('canViewCheckProdukcja')"
				:class="{'active': $page.url.startsWith('/CheckProduction')}">
              <Link :href="route('check_production.index')"> Status produkcji</Link>
            </li>				
          </ul>
        </li>

        <li class="menu" v-if="hasPermission('canViewPurchases')"
            :class="{'active': $page.url.startsWith('/warehouse')}">
          <Link href="#articles" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-warehouse">
                <rect x="3" y="10" width="18" height="10" stroke="currentColor" fill="none"/>
                <polyline points="3 10 12 3 21 10" stroke="currentColor" fill="none"/>
                <rect x="7" y="14" width="3" height="3" stroke="currentColor" fill="none"/>
                <rect x="14" y="14" width="3" height="3" stroke="currentColor" fill="none"/>
              </svg>
              <span>Zakupy</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>
		  
          <ul class="submenu list-unstyled collapse" id="articles" data-bs-parent="#accordionMenu" style="">
            <li v-if="hasPermission('canViewOpisyFaktur')"
                :class="{'active': $page.url === '/warehouse/opisy_faktur'}">
              <Link :href="route('warehouse.opisy_faktur')">Opisy faktur</Link>
            </li>          
            <li v-if="hasPermission('canViewOpisyFaktur')"
                :class="{'active': $page.url === '/warehouse/faktury'}">
              <Link :href="route('warehouse.faktury')">Lista faktur</Link>
            </li> 
			
		  <li v-if="!hasPermission('canRequiredProjectItemsViewOnly')" :class="{'active': $page.url === '/warehouse/articles'}">
              <Link :href="route('articles.index')">Lista artykułów</Link>
            </li>
            <li v-if="hasPermission('canEditRequiredProjectItems') || hasPermission('canRequiredProjectItemsViewOnly')"  :class="{'active': $page.url === '/required-project-items'}">
              <Link :href="route('requiredProjectItems.index')">Zapotrzebowanie<br> projektowe</Link>
            </li>
			
			<li v-if="hasPermission('canUseInventorParser')"
				:class="{'active': $page.url.startsWith('/inventor/parser')}">
              <Link :href="route('inventor.parser.index')"> Wczytaj z inventora</Link>
            </li>
			
            <li v-if="hasPermission('canViewQuoteRequests')" :class="{'active': $page.url === '/quote-requests'}">
              <Link :href="route('quoteRequests.index')">Zapytania ofertowe</Link>
            </li>
			
            <li v-if="hasPermission('canChangeStatusApprovalOrders')"
                :class="{'active': $page.url === '/order-lists?status=W%20zatwierdzeniu'}">
              <Link :href="route('orderLists.index',{status:'W zatwierdzeniu'})">Zam. Do zatwierdzenia</Link>
            </li>
            <li v-if="hasPermission('canViewOrders') && hasPermission('canEditOrders')"
                :class="{'active': $page.url === '/order-lists?status=Zatwierdzone'}">
              <Link :href="route('orderLists.index',{status:'Zatwierdzone'})">Zam. Zatwierdzone</Link>
            </li>
            <li v-if="hasPermission('canViewOrders')"
                :class="{'active': $page.url === '/order-lists?status=Cz%C4%99%C5%9Bciowo%20zrealizowane'}">
              <Link :href="route('orderLists.index',{status:'Częściowo zrealizowane'})">Zam. Częs. Zrealizowane</Link>
            </li>
            <li v-if="hasPermission('canViewOrders')"
                :class="{'active': $page.url === '/order-lists?status=Zrealizowane'}">
              <Link :href="route('orderLists.index',{status:'Zrealizowane'})">Zam. Zrealizowane</Link>
            </li>
            <li v-if="hasPermission('canViewOrders')"
                :class="{'active': $page.url === '/order-lists?status=Anulowane'}">
              <Link :href="route('orderLists.index',{status:'Anulowane'})">Zam. Anulowane</Link>
            </li>

            <li v-if="hasPermission('canViewOrders')"
                :class="{'active': $page.url === '/order-lists?status=Zam%C3%B3ienie%20wys%C5%82ane'}">
              <Link :href="route('orderLists.index',{status:'Zamówienie wysłane'})">Zam. Wysłane</Link>
            </li>
            <li v-if="hasPermission('canViewOrders')" :class="{'active': $page.url === '/order-lists'}">
              <Link :href="route('orderLists.index')">Zamówienia</Link>
            </li>
            <li v-if="hasPermission('canViewWarehouse')" :class="{'active': $page.url === '/warehouse'}">
              <Link :href="route('warehouse.index')">Stany magazynowe</Link>
            </li>
            <li v-if="hasPermission('canViewWarehouseMovements')" :class="{'active': $page.url === '/warehouses'}">
              <Link :href="route('warehouse-reservations.index')"
                    :class="{'active': $page.url === '/warehouse-reservations'}">Rezerwacje
              </Link>
              <Link :href="route('warehouse-movements.index')"
                    :class="{'active': $page.url === '/warehouse-movements'}">Ruchy magazynowe
              </Link>
            </li>
            <li v-if="hasPermission('canCreatorSettings')" :class="{'active': $page.url === '/creator-settings'}">
              <Link :href="route('creator.settings')">Kreator - Ustawienia</Link>
            </li>			
            <li v-if="hasPermission('canZakupySettings')" :class="{'active': $page.url === '/order-settings'}">
              <Link :href="route('orderLists.settings')">Ustawienia</Link>
            </li>
            <li v-if="hasPermission('canZakupyStats')" :class="{'active': $page.url === '/order-stats'}">
              <Link :href="route('orderLists.stats')">Statystyki zamówień</Link>
            </li>			
		  </ul>
        </li>

        <li v-if="hasPermission('canViewService')" class="menu"
            :class="{'active': $page.url.startsWith('/service/zestawienia')}">
          <Link href="#service" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed"
                preverse-state>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-tool">
                <path
                    d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>


              </svg>
              <span>Serwis</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="service" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canViewService')" :class="{'active': $page.url === '/service'}">
              <Link :href="route('service.index')"> Lista zgłoszeń</Link>
            </li>
            <li v-if="hasPermission('canAddService')" :class="{'active': $page.url.startsWith('/service/create')}">
              <Link :href="route('service.create')"> Dodaj zgłoszenie</Link>
            </li>

            <li v-if="hasPermission('canViewRate')" :class="{'active': $page.url.startsWith('/service/servicecat')}">
              <Link :href="route('service.servicecat.index')"> Stawki serwisowe</Link>
            </li>
            <li v-if="hasPermission('canViewServiceCategory')"
                :class="{'active': $page.url.startsWith('/service/servicecatcategory')}">
              <Link :href="route('service.servicecatcategory.index')"> Kategorie serwisowe</Link>
            </li>
            <li v-if="hasPermission('canViewSerwisZestawienia')" :class="{'active':
                $page.url.startsWith('/service/zestawienia')}">
              <Link :href="route('get.service.zestawienia')"> Zestawienia</Link>
            </li>

          </ul>
        </li>

        <li v-if="!hasPermission('canViewKsiegowosc')"class="menu"
            :class="{'active': $page.url === '/worktime/index' || $page.url === '/pracownik/godziny' || $page.url === '/kanban/boards'  || $page.url === '/urlopy/index' || $page.url === '/kaizen' || $page.url === '/vcf' || $page.url === '/stopka' || $page.url === '/autoresponder' || $page.url === '/cert/komunikaty'}">
          <Link href="#Pracownik" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed"
                preverse-state>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-user">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>Pracownik</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="Pracownik" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canAddWorktime')" :class="{'active': $page.url === '/worktime/index'}">
              <Link :href="route('worktime.index')"> Czas pracy</Link>
            </li>
            <li v-if="hasPermission('canViewCardRead') || hasPermission('canViewCardRead2')" :class="{'active': $page.url === '/pracownik/godziny'}">
              <Link :href="route('pracownik.godziny.index')"> Odbicia karty</Link>
            </li>			
            <li :class="{'active': $page.url === '/urlopy/index'}">
              <Link :href="route('urlopy.index')"> Wolne - Delegacje</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/kanban/boards')}">
              <Link :href="route('kanban.boards.index')" preserve-state> Tablice zadań</Link>
            </li>				
            <li :class="{'active': $page.url.startsWith('/kaizen')}">
              <Link :href="route('kaizen.index')" preserve-state> Pomysły KaiZen</Link>
            </li>				
            <li :class="{'active': $page.url.startsWith('/vcf')}">
              <Link :href="route('vcf.list')" preserve-state> Kontakty</Link>
            </li>	
			<li :class="{'active': $page.url.startsWith('/stopka')}">
			  <a :href="route('stopka.show')" target="_blank"  rel="noopener noreferrer" @click.stop>
				Stopka e-mail
			  </a>
			</li>	
            <li :class="{'active': $page.url === '/autoresponder'}">
              <Link :href="route('autoresponder.show')"> Autoresponder e-mail</Link>
            </li>			
            <li :class="{'active': $page.url === '/cert/komunikaty'}">
              <Link :href="route('cert.index')"> Komunikaty CERT</Link>
            </li>
		  </ul>
        </li>

        <li v-if="hasRole('ADMIN') || hasRole('KIEROWNIK') || hasRole('Z-CA KIEROWNIKA' || hasPermission('canViewKaiZen'))" class="menu"
            :class="{'active': $page.url === '/dyzury/lista' || $page.url === '/praca/niedziela/lista'  || $page.url === '/kaizen/list' || $page.url === '/urlopy/lista' || $page.url === '/lista/obecnosci'}">
          <Link href="#Kierownik" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed"
                preverse-state>
            <div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user-check"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>
              <span>Kierownik</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="Kierownik" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canViewDyzury')" :class="{'active': $page.url === '/dyzury/lista'}">
              <Link :href="route('dyzury.lista')"> Dyżury</Link>
            </li>	
            <li v-if="hasPermission('canViewDyzury')" :class="{'active': $page.url === '/praca/niedziela/lista'}">
              <Link :href="route('praca.niedziela.lista')"> Praca w niedzielę</Link>
            </li>				
            <li v-if="hasPermission('canViewKaiZen')"
                :class="{'active': $page.url === '/kaizen/list'}">
              <Link :href="route('kaizen.list')"> Głosowanie KaiZen</Link>
            </li>			
            <li v-if="hasRole('ADMIN') || hasRole('KIEROWNIK') || hasRole('Z-CA KIEROWNIKA') || hasPermission('canViewUrlopyDzial')"
                :class="{'active': $page.url === '/urlopy/lista'}">
              <Link :href="route('urlopy.lista')"> Wolne pracowników</Link>
            </li>
            <li v-if="hasRole('ADMIN') || hasRole('KIEROWNIK')|| hasRole('Z-CA KIEROWNIKA') || hasPermission('canViewUrlopyDzial')"
                :class="{'active': $page.url === '/lista/obecnosci'}">
              <Link :href="route('lista.obecnosci')"> Lista obecności</Link>
            </li>
		  </ul>
        </li>
		
        <li v-if="hasPermission('canViewKadry')" class="menu"
            :class="{'active': $page.url.startsWith('/kadry/') || $page.url.startsWith('/worktime/office')}">
          <Link href="#kadry" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed"
                preverse-state>
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                <rect x="8" y="16" width="48" height="40" rx="4" ry="4" stroke="#2c3e50" stroke-width="3"/>
                <rect x="22" y="10" width="20" height="8" rx="2" ry="2" fill="#34495e"/>
                <text x="32" y="34" font-family="Arial, sans-serif" font-weight="bold" font-size="28" fill="#2c3e50"
                      text-anchor="middle" alignment-baseline="middle">HR
                </text>
              </svg>
              <span>Kadry</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="kadry" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canViewUrlopy')" :class="{'active': $page.url === '/kadry/urlopy/'}">
              <Link :href="route('kadry.urlopy.lista')"> Urlopy pracowników</Link>
            </li>
            <li v-if="hasPermission('canViewWorkersDane')" :class="{'active': $page.url === '/kadry/lista/'}">
              <Link :href="route('kadry.lista')"> Pracownicy</Link>
            </li>
            <li v-if="hasPermission('canViewWorkersDane')" :class="{'active': $page.url === '/aktualizuj-urlopy'}">
              <Link :href="route('kadry.urlopy.nowy-rok')"> Planowanie urlopów</Link>
            </li>			
            <li v-if="hasPermission('canViewWatcher')"
                :class="{'active': $page.url === '/watcher'}">
              <Link :href="route('watcher.index')"> Watcher</Link>
            </li>			
            <li v-if="hasPermission('canViewWorkersDane')" :class="{'active': $page.url === '/kadry/delegacje'}">
              <Link :href="route('kadry.delegacje')"> Delegacje</Link>
            </li>
            <li :class="{'active': $page.url === '/kadry/terminy/lista/'}">
              <Link :href="route('kadry.terminy.lista')"> Terminy - lista</Link>
            </li>
			<li v-if="hasPermission('canEditKadry') && ($page.url === '/kadry/faktury' || ($page.url !== '/kadry/faktury_out' && $page.url !== '/kadry/opisy_faktur')) "
                :class="{ active: $page.url === '/kadry/faktury'}">
              <Link :href="route('kadry.faktury')">Faktury KSEF</Link>
            </li>	
            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/faktury_out'"
                :class="{ active: $page.url === '/kadry/faktury_out'}">
              <Link :href="route('kadry.faktury_out')">Faktury KSEF</Link>
            </li>			
            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/opisy_faktur'"
                :class="{ active: $page.url === '/kadry/opisy_faktur'}">
              <Link :href="route('kadry.opisy_faktur')">Faktury KSEF</Link>
            </li>				
            <li v-if="hasPermission('canChangeStatusKaiZen')"
                :class="{ active: $page.url === '/kaizen/kadry'}">
              <Link :href="route('kaizen.hr')">Lista KaiZen</Link>
            </li>				
            <li v-if="$page.url === '/kadry/zestawienia_wolne'|| ($page.url !== '/kadry/karty_ewidencji' && $page.url !== '/kadry/zestawienia' && $page.url !== '/worktime-office' && $page.url !== '/kadry/odbicia' && $page.url !== '/kadry/dyski-sieciowe' && $page.url !== '/uprawnienia-erp' && $page.url !== '/kadry/dyzury/lista'&& $page.url !== '/kadry/praca/niedziela/lista')"
                :class="{ active: $page.url === '/kadry/zestawienia_wolne'}">
              <Link :href="route('kadry.zestawienia.wolne')">Zestawienia</Link>
            </li>
            <li v-if="$page.url === '/kadry/karty_ewidencji'"
                :class="{ active: $page.url === '/kadry/karty_ewidencji'}">
              <Link :href="route('kadry.karty_ewidencji')">Zestawienia</Link>
            </li>
            <li v-if="$page.url === '/kadry/zestawienia'" :class="{ active: $page.url === '/kadry/zestawienia'}">
              <Link :href="route('kadry.zestawienia')">Zestawienia</Link>
            </li>
            <li v-if="$page.url === '/kadry/karty_odbicia'" :class="{ active: $page.url === '/kadry/karty_odbicia'}">
              <Link :href="route('kadry.kartyOdbicia')">Zestawienia</Link>
            </li>
            <li v-if="$page.url === '/worktime-office'" :class="{ active: $page.url === '/worktime-office'}">
              <Link :href="route('worktime.office.index')">Zestawienia</Link>
            </li>
            <li v-if="$page.url === '/kadry/dyzury/lista'" :class="{ active: $page.url === '/kadry/dyzury/lista'}">
              <Link :href="route('kadry.dyzury.lista')">Zestawienia</Link>
            </li>			
            <li v-if="$page.url === '/kadry/praca/niedziela/lista'" :class="{ active: $page.url === '/kadry/praca/niedziela/lista'}">
              <Link :href="route('kadry.praca.niedziela.lista')">Zestawienia</Link>
            </li>			
            <li v-if="$page.url === '/kadry/odbicia'" :class="{ active: $page.url === '/kadry/odbicia'}">
              <Link :href="route('kadry.odbicia.index')">Zestawienia</Link>
            </li>
            <li v-if="$page.url === '/kadry/dyski-sieciowe'" :class="{ active: $page.url === '/kadry/dyski-sieciowe'}">
              <Link :href="route('kadry.dyski.index')">Zestawienia</Link>
            </li>
            <li v-if="$page.url === '/uprawnienia-erp'" :class="{ active: $page.url === '/uprawnienia-erp'}">
              <Link :href="route('uprawnienia.erp')">Zestawienia</Link>
            </li>	
            <li v-if="hasPermission('canEditKadry') && ($page.url === '/kadry/terminy/typy' || ($page.url !== '/kadry/ustawienia/dni_wolne' && $page.url !== '/kadry/dni_wolne' && $page.url !== '/kadry/rodzaje_umow' && $page.url !== '/kadry/etaty_typy' && $page.url !== '/kadry/settings' && $page.url !== '/kadry/rodzaje_godzin'))"
                :class="{ active: $page.url === '/kadry/terminy/typy'}">
              <Link :href="route('kadry.terminy.typy')">Ustawienia</Link>
            </li>
            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/dni_wolne'"
                :class="{ active: $page.url === '/kadry/dni_wolne'}">
              <Link :href="route('kadry.urlopy.typy')">Ustawienia</Link>
            </li>
            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/rodzaje_umow'"
                :class="{ active: $page.url === '/kadry/rodzaje_umow'}">
              <Link :href="route('kadry.typ_umowy.lista')">Ustawienia</Link>
            </li>
            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/etaty_typy'"
                :class="{ active: $page.url === '/kadry/etaty_typy'}">
              <Link :href="route('kadry.etaty.typy')">Ustawienia</Link>
            </li>
            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/settings'"
                :class="{ active: $page.url === '/kadry/settings'}">
              <Link :href="route('kadry.settings')">Ustawienia</Link>
            </li>

            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/rodzaje_godzin'"
                :class="{ active: $page.url === '/kadry/rodzaje_godzin'}">
              <Link :href="route('kadry.typy_godzin.lista')">Ustawienia</Link>
            </li>
            <li v-if="hasPermission('canEditKadry') && $page.url === '/kadry/ustawienia/dni_wolne'"
                :class="{ active: $page.url === '/kadry/ustawienia/dni_wolne'}">
              <Link :href="route('kadry.dni.wolne')">Ustawienia</Link>
            </li>
			<li v-if="hasPermission('canEditKadry')"
                :class="{ active: $page.url === '/kadry/skierowania'}">
              <Link :href="route('kadry.skierowania')">Badania lekarskie</Link>
            </li>	
			<li v-if="hasPermission('canEditKadry')"
                :class="{ active: $page.url === '/kadry/newsy'}">
              <Link :href="route('kadry.newsy')">Wiadomości</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/kadry/mail')}">
              <Link :href="route('kadry.mail')" preserve-state> Informacje na e-mail</Link>
            </li>			
		  </ul>
        </li>

       <li v-if="hasPermission('canViewKsiegowosc')" class="menu"
            :class="{'active': $page.url.startsWith('/ksiegowosc/')}">
          <Link href="#ksiegowosc" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed"
                preverse-state>
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                <rect x="8" y="16" width="48" height="40" rx="4" ry="4" stroke="#2c3e50" stroke-width="3"/>
                <rect x="22" y="10" width="20" height="8" rx="2" ry="2" fill="#34495e"/>
                <text x="32" y="34" font-family="Arial, sans-serif" font-weight="bold" font-size="28" fill="#2c3e50"
                      text-anchor="middle" alignment-baseline="middle">HR
                </text>
              </svg>
              <span>Księgowość</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="ksiegowosc" data-bs-parent="#accordionMenu">
			<li v-if="hasPermission('canViewKsiegowosc')"
                :class="{ active: $page.url === '/ksiegowosc/faktury'}">
              <Link :href="route('ksiegowosc.faktury')">Faktury KSEF</Link>
            </li>	
          </ul>
        </li>
		
        <li v-if="hasPermission('canViewBHP') || hasPermission('canViewUbrania')" class="menu"
            :class="{'active': $page.url.startsWith('/bhp/')}">
          <Link href="#bhp" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle collapsed"
                preverse-state>
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-first-aid">
                <rect x="3" y="7" width="18" height="14" rx="2" ry="2"/>
                <path d="M12 11v6"/>
                <path d="M9 14h6"/>
                <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
              </svg>
			  
              <span>BHP / Odzież</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="bhp" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canViewBHP')"
                :class="{ 'active': $page.url === '/bhp/terminy/lista' || $page.url.startsWith('/bhp/terminy/show/user/') }">
              <Link :href="route('bhp.terminy.lista')">Terminy pracowników</Link>
            </li>
            <li v-if="hasPermission('canViewUbrania') && ($page.url === '/bhp/terminy/ubran' || ($page.url !== '/bhp/rozmiary/ubran' && $page.url !== '/bhp/stan/odziezy'))"
                :class="{ active: $page.url === '/bhp/terminy/ubran'}">
              <Link :href="route('bhp.terminy.ubran')">Odzież ochronna</Link>
            </li>
            <li v-if="hasPermission('canViewUbrania') && $page.url === '/bhp/rozmiary/ubran'"
                :class="{ active: $page.url === '/bhp/rozmiary/ubran'}">
              <Link :href="route('bhp.rozmiary.ubran')">Odzież ochronna</Link>
            </li>
            <li v-if="hasPermission('canViewUbrania') && $page.url === '/bhp/stan/odziezy'"
                :class="{ active: $page.url === '/bhp/stan/odziezy'}">
              <Link :href="route('bhp.stan.odziezy')">Odzież ochronna</Link>
            </li>
            <li v-if="hasPermission('canViewUbrania') && $page.url === '/bhp/zestawy/asekuracyjne'"
                :class="{ active: $page.url === '/bhp/zestawy/asekuracyjne'}">
              <Link :href="route('bhp.zestawy.asekuracyjne')">Odzież ochronna</Link>
            </li>			
            <li v-if="hasPermission('canViewBHP')"
                :class="{ active: $page.url === '/bhp/skierowania'}">
              <Link :href="route('bhp.skierowania')">Szablony skierowań</Link>
            </li>			
            <template v-if="hasPermission('canEditBHP') && !hasPermission('canEditUbrania')">
              <li v-if="$page.url === '/bhp/terminy/typy' || ($page.url !== '/bhp/grupy' && $page.url !== '/bhp/grupy/artykuly')"
                  :class="{ active: $page.url === '/bhp/terminy/typy'}">
                <Link :href="route('bhp.terminy.typy')">Ustawienia</Link>
              </li>
            </template>
            <template v-if="hasPermission('canEditBHP') && hasPermission('canEditUbrania')">
              <li v-if="$page.url === '/bhp/terminy/typy' || ($page.url !== '/bhp/grupy' && $page.url !== '/bhp/grupy/artykuly')"
                  :class="{ active: $page.url === '/bhp/terminy/typy'}">
                <Link :href="route('bhp.terminy.typy')">Ustawienia</Link>
              </li>
              <li v-if="$page.url === '/bhp/grupy'" :class="{ active: $page.url === '/bhp/grupy'}">
                <Link :href="route('bhp.grupy')">Ustawienia</Link>
              </li>
              <li v-if="$page.url === '/bhp/grupy/artykuly'" :class="{ active: $page.url === '/bhp/grupy/artykuly'}">
                <Link :href="route('bhp.grupy.artykuly')">Ustawienia</Link>
              </li>
            </template>
            <template v-if="!hasPermission('canEditBHP') && hasPermission('canEditUbrania')">
              <li v-if="$page.url === '/bhp/grupy' || $page.url !== '/bhp/grupy/artykuly'"
                  :class="{ active: $page.url === '/bhp/grupy'}">
                <Link :href="route('bhp.grupy')">Ustawienia</Link>
              </li>
              <li v-if="$page.url === '/bhp/grupy/artykuly'" :class="{ active: $page.url === '/bhp/grupy/artykuly'}">
                <Link :href="route('bhp.grupy.artykuly')">Ustawienia</Link>
              </li>
            </template>
          </ul>
        </li>


        <li v-if="hasPermission('canViewConferenceRoom')" class="menu"
            :class="{'active': $page.url.startsWith('/conferencerooms') || $page.url.startsWith('/conferenceroom/rooms')}">
          <Link href="#conferencerooms" data-bs-toggle="collapse" aria-expanded="false"
                class="dropdown-toggle collapsed" preverse-state>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-calendar">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M7 8h10v8H7z"></path>
                <path d="M7 12h10"></path>
                <path d="M10 5v4"></path>
                <path d="M14 5v4"></path>
              </svg>
              <span>Salki</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>

          <ul class="submenu list-unstyled collapse" id="conferencerooms" data-bs-parent="#accordionMenu">
            <li v-if="hasPermission('canViewConferenceRoom')"
                :class="{'active': $page.url === '/conferencerooms/index'}">
              <Link :href="route('conferencerooms.index')"> Harmonogram</Link>
            </li>
            <li v-if="hasPermission('canAddConferenceRooms')"
                :class="{'active': $page.url.startsWith('/conferencerooms/show')}">
              <Link :href="route('conferencerooms.list')"> Salki</Link>
            </li>
          </ul>
        </li>

        <li v-if="hasRole('ADMIN')" class="menu" :class="{'active': $page.url.startsWith('/users')}">
          <Link href="#users" data-bs-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-users">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span>Administracja</span>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-chevron-right">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </Link>
          <ul class="submenu list-unstyled collapse" id="users" data-bs-parent="#accordionMenu" style="">
            <li :class="{'active': $page.url === '/users'}">
              <Link :href="route('users.index')"> Lista użytkowników</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/users/create')}">
              <Link :href="route('users.create')" preserve-state> Utwórz użytkownika</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/users/departments')}">
              <Link :href="route('users.departments.index')" preserve-state> Działy użytkowników</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/admin/users/logs')}">
              <Link :href="route('admin.users.logs')" preserve-state> Logowania</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/smb/users')}">
              <Link :href="route('smb.users')" preserve-state> Dyski sieciowe</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/admin/rcb')}">
              <Link :href="route('admin.rcb')" preserve-state> Powiadomienia</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/admin/phising')}">
              <Link :href="route('admin.phising')" preserve-state> Phishing - testy</Link>
            </li>
            <li :class="{'active': $page.url.startsWith('/admin/tables/reset')}">
              <Link :href="route('admin.tables.reset')" preserve-state> Tabele - przywracanie</Link>
            </li>
			
		  </ul>
        </li>
      </ul>
    </nav>
  </div>
  <!--  END SIDEBAR  -->
</template>

<script>
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";

export default {
  methods: {route},

  setup({el, App, props, plugin}) {
    const vueApp = createApp({render: () => h(App, props)});

    // Globalne wywołanie feather.replace() na każdym montowaniu komponentu
    vueApp.mixin({
      mounted() {
        feather.replace();
      },
    });

    vueApp.use(plugin).mount(el);
  },

}
</script>
